import {Box, Button, IconButton, styled, Typography} from "@mui/material";
import {color} from "../../theme/includes/color";

export const DialogWrapper = styled(Box)({})
export const DialogCloseButton = styled(IconButton)({
  padding: 0,
  position: 'absolute',
  top: '40px',
  right: '40px',
  ':hover': {
    backgroundColor: 'transparent',
  }
})
export const DialogProfileContent = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  marginBottom: '24px'

})
export const DialogProfileField = styled(Typography)({
  fontSize: '24px',
  color: color('grey-500'),
})
export const DialogProfileName = styled(Typography)({
  fontSize: '24px',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
export const DialogLogOutButton = styled(Button)({
  width: '100%',
  color: color('black-100'),
  borderRadius: '16px',
  backgroundColor: color('grey-600'),
  border: '2px solid transparent',
  ":hover": {
    backgroundColor: color('grey-600'),
    border: `2px solid ${color('grey-400')}`,
  }
})
export const NavLinkToProfile = styled(Button)({
  minWidth: '213px',
  padding: '4px 8px',
  borderRadius: '48px',
  color: color('black-100'),
  backgroundColor: color('white-100'),
  textTransform: 'capitalize',
  justifyContent: 'flex-start',
  ':hover': {
    backgroundColor: color('white-100'),
    opacity: .8
  }
})